export function extension(filename) {
    const r = /.+\.(.+)$/.exec(filename);
    return r ? r[1] : null;
}